import React from 'react';
import MortgageRatesSummary from './MortgageRatesSummary.js';

var MortgageRatesSummaryBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var _attrs$pathname = attrs.pathname,
      pathname = _attrs$pathname === void 0 ? '/mortgage-rates/' : _attrs$pathname;
    return /*#__PURE__*/React.createElement(MortgageRatesSummary, {
      pathname: pathname
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/mortgage-rates-summary',
    title: 'Mortgage Rates Summary',
    description: 'mortgage rates summary',
    icon: 'businessperson',
    keywords: ['mortgages', 'calculators', 'rates'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'Layout',
    attributes: {
      pathname: {
        type: 'string',
        label: 'Path',
        default: '/mortgage-rates/',
        control: 'text'
      }
    }
  }
};
var MortgageRatesSummaryBlock$1 = MortgageRatesSummaryBlock;

export { MortgageRatesSummaryBlock$1 as default };
